module.exports = __webpack_public_path__ + "static/media/tanque-cheio-de-premios_768.d0fa5946.png";